import React, {useEffect, useRef, useState} from "react";
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import {CONTAINS, DOES_NOT_CONTAIN} from "../constants";


export const TextColumnFilter = ({colDef, onChange}) => {

    const [filterState, setFilterState] = useState({
        columnDef: colDef,
        operator: null,
        operand: null,
        between: {
            start: null,
            end: null
        }
    });

    return <div
        className={"canold-table-column-text-filter-container"}
        role={"canold-table-column-text-filter-container"}
    >
        <FormControl>
            <FormLabel className={"column-table-filter-label"} id={"canold-table-column-text-filter-radio-" + colDef.getIndex()} ></FormLabel>
            <RadioGroup
                aria-labelledby="canold-table-column-text-filter-radio-group"
                defaultValue={CONTAINS}
                name="canold-table-column-text-filter-radio-group"
            >
                <FormControlLabel
                    checked={filterState?.operator === CONTAINS}
                    role={"canold-table-filter-contains"}
                    value={CONTAINS}
                    control={<Radio />}
                    label={<p>that contain</p>}
                    onChange={(evt) => {
                        const newState = {...filterState, operator: evt.target.value};
                        setFilterState(newState);
                        onChange(colDef, newState, evt);
                    }}/>
                <FormControlLabel
                    checked={filterState?.operator === DOES_NOT_CONTAIN}
                    role={"canold-table-filter-does-not-contain"}
                    value={DOES_NOT_CONTAIN}
                    control={<Radio />}
                    label={<p>that do not contain</p>}
                    onChange={(evt) => {
                        const newState = {...filterState, operator: evt.target.value};
                        setFilterState(newState);
                        onChange(colDef, newState, evt);
                    }}/>
            </RadioGroup>
        </FormControl>
        <FormControl>
            <input
                type={"text"}
                role={"canold-table-column-text-filter-input"}
                onChange={(evt) => {
                    evt.stopPropagation();
                    const newFilterState = {
                        ...filterState,
                        operand: evt.target.value
                    };
                    setFilterState(newFilterState);
                    onChange(colDef, newFilterState, evt);
                }}
                placeholder={"Search Term"}
                className={"canold-table-column-filter-input"}
            />
        </FormControl>
    </div>;

};


export default TextColumnFilter;